import {combineReducers} from 'redux';

// @ts-expect-error
import {ActionTypes, TinyIntroAction} from './tiny-intro-actions';
import type {SignupStartPage} from './types';

type EmailState = TinyIntroState['userEmail'];
export const userEmail = (
    state: EmailState | null | undefined = null,
    action: TinyIntroAction
): EmailState => {
    switch (action.type) {
        case ActionTypes.TINY_INTRO_SET_EMAIL:
            return action.payload;
        default:
            return state;
    }
};

type SignupTokenState = TinyIntroState['userSignupToken'];
export const userSignupToken = (
    state: SignupTokenState | null | undefined = null,
    action: TinyIntroAction
): SignupTokenState => {
    switch (action.type) {
        case ActionTypes.TINY_INTRO_SET_SIGNUP_TOKEN:
            return action.payload;
        default:
            return state;
    }
};

type SignupStartPageState = TinyIntroState['signupStartPage'];
export const signupStartPage = (
    state: SignupStartPageState | null | undefined = null,
    action: TinyIntroAction
): SignupStartPageState => {
    switch (action.type) {
        case ActionTypes.TINY_INTRO_SET_SIGNUP_START_PAGE:
            return action.payload;
        default:
            return state;
    }
};

type AccountProvisionedState = {
    status: boolean;
    instanceId: string | null | undefined;
    emailSha1: string | null | undefined;
};

export const userAccountProvisionResponse = (
    state: AccountProvisionedState | null | undefined = {
        status: false,
        instanceId: null,
        emailSha1: null,
    },
    action: TinyIntroAction
): AccountProvisionedState => {
    switch (action.type) {
        case ActionTypes.TINY_INTRO_SET_PROVISION_RESPONSE:
            return action.payload;
        default:
            // @ts-expect-error
            return state;
    }
};

type AccountProvisionedErrorMessage = TinyIntroState['userAccountProvisionedErrorMessage'];
export const userAccountProvisionedErrorMessage = (
    state: AccountProvisionedErrorMessage | null | undefined = null,
    action: TinyIntroAction
): AccountProvisionedErrorMessage => {
    switch (action.type) {
        case ActionTypes.TINY_INTRO_SET_PROVISION_ERROR_MESSAGE:
            return action.payload;
        default:
            return state;
    }
};

export type TinyIntroState = {
    userEmail: string | null | undefined;
    userSignupToken: string | null | undefined;
    signupStartPage: SignupStartPage;
    userAccountProvisionResponse: AccountProvisionedState;
    userAccountProvisionedErrorMessage: string | null | undefined;
};

export const tinyIntroReducer = combineReducers({
    userEmail,
    userSignupToken,
    signupStartPage,
    userAccountProvisionResponse,
    userAccountProvisionedErrorMessage,
});
